import pose1 from '../assets/pose1.svg';
import pose2 from '../assets/pose2.png';
import pose3 from '../assets/pose3.png';
import pose4 from '../assets/pose4.png';

export const programsData = [
  {
    image: pose1,
    heading: 'Online free Classes',
    details:
      'Click here to start your free path to the wonderful world of yoga with our classes on YouTube',
  },
  {
    image: pose2,
    heading: 'Regular Online Classes',
    details:
      'Be part of our community of yogis with a regular live yoga class, where you can improve your practice with our teachers.',
  },
  {
    image: pose3,
    heading: 'Personal Online Classes',
    details:
      'Improve your technic with a personal teacher with focus in you necessityes, this is a only for you class',
  },
  {
    image: pose4,
    heading: 'Online Workshops',
    details:
      'Get deeper with our online workshops of meditation, asanas, self-knowlogy and yoga culture',
  },
];
